import { useCallback, useEffect, useMemo } from 'react'
import { useAuth, useFeatureFlag } from '@/hooks'

const INDECX_WIDGET_SRC_URL =
  'https://indecx-widget.s3.amazonaws.com/widget-production-v3.js'

export const useIndecx = (): void => {
  const { nome, email, estaAutenticado } = useAuth()
  const indecxConfig = useFeatureFlag('indecx')

  const dadosConsumidor = useMemo(() => {
    return {
      key: indecxConfig?.Widgetkey,
      action: indecxConfig?.Action,
      name: nome,
      email,
      phone: '',
      indicators: {},
      width: 600,
      height: 400,
    }
  }, [nome, email, indecxConfig])

  const executarPlugin = useCallback(() => {
    if (typeof window.IndeCX !== 'function') return
    if (!dadosConsumidor.name || !dadosConsumidor.email) return

    window.IndeCX(dadosConsumidor)
  }, [dadosConsumidor])

  const carregarScript = useCallback(async () => {
    if (document.getElementById('indecx-script')) {
      executarPlugin()
      return
    }

    const script = document.createElement('script')
    script.id = 'indecx-script'
    script.src = INDECX_WIDGET_SRC_URL
    script.async = true
    script.type = 'text/javascript'

    const scriptPromise = new Promise<void>((resolve, reject) => {
      script.onload = () => resolve()
      script.onerror = err => reject(err)
    })

    document.body.appendChild(script)

    try {
      await scriptPromise
      executarPlugin()
    } catch (err) {
      console.error('❌ Falha ao carregar o script IndeCX:', err)
    }
  }, [executarPlugin])

  useEffect(() => {
    if (!estaAutenticado || !indecxConfig) return
    carregarScript()
  }, [estaAutenticado, indecxConfig, carregarScript])
}
